import { render, staticRenderFns } from "./AllocateChassisModal.vue?vue&type=template&id=fb40769a"
import script from "./AllocateChassisModal.vue?vue&type=script&lang=js"
export * from "./AllocateChassisModal.vue?vue&type=script&lang=js"
import style0 from "./AllocateChassisModal.vue?vue&type=style&index=0&id=fb40769a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports